export default "__VITE_ASSET__B6BZw_L8__"